import styled from 'styled-components';

import { Announcement } from 'ui/announcement';
import { ANNOUNCEMENT_VARIANTS } from 'ui/announcement/constants';
import { body2Bold } from 'ui/theme';

const Content = styled.span`
  display: inline-flex;
  & > p {
    ${body2Bold};
    color: inherit;
  }
`;

export const EditSavedRowDesignWarning = () => (
  <Announcement variant={ANNOUNCEMENT_VARIANTS.INFO}>
    <Content>
      You are editing a saved row. Changes will&nbsp;<p>only</p>&nbsp;apply to future templates that
      use this row.
    </Content>
  </Announcement>
);
